import React from "react";
import { Box, Button, HStack, Text, useColorMode } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import InsightsSection from "./InsightsSection";
import PlaceholderTile from "./PlaceholderTile";

const OptionsSection = ({ optionsExpiry = [] }) => {
  const { colorMode } = useColorMode();
  const cardBg = colorMode === "light" ? "gray.50" : "gray.600";
  const labelColor = colorMode === "light" ? "gray.600" : "gray.300";
  const navigate = useNavigate();

  const hasData = Array.isArray(optionsExpiry) && optionsExpiry.length > 0;

  return (
    <InsightsSection
      title="Options Stats"
      description="Performance bucketed by days-to-expiry. Tap through for the full breakdown."
    >
      {hasData ? (
        <>
          <HStack spacing={3} mb={3} overflowX="auto">
            {optionsExpiry.map((b) => (
              <Box key={b.bucket} bg={cardBg} rounded="md" p={3} minW="150px">
                <Text fontSize="xs" color={labelColor}>{b.bucket}</Text>
                <Text fontSize="md" fontWeight="bold">
                  {b.win_pct != null ? `${b.win_pct}% WR` : "—"}
                </Text>
                <Text fontSize="xs" color={labelColor}>
                  {b.num_trades} trade{b.num_trades === 1 ? "" : "s"}
                </Text>
              </Box>
            ))}
          </HStack>
          <Button size="sm" onClick={() => navigate("/options-analytics")}>
            View Options Analytics →
          </Button>
        </>
      ) : (
        <PlaceholderTile message="No options trades with expiry data yet — log options trades to see DTE buckets." />
      )}
    </InsightsSection>
  );
};

export default OptionsSection;
